import React, { useEffect, useState } from "react";
import CountDown from "../../components/others/CountDown";

const PrayerAdvertise = ({ prayers }) => {
  const [time, setTime] = useState(null);
  const [prayerItems, setPrayerItems] = useState([]);

  const tick = () => {
    // Get the current time
    const currentTime = new Date();

    // Find the next time in the current day
    let nextTime = null;
    let highlightItem = null;

    for (let i = 0; i < prayers.length; i++) {
      const timeParts = prayers[i].timeValues.split(":");
      const time = new Date();
      time.setHours(parseInt(timeParts[0]));
      time.setMinutes(parseInt(timeParts[1]));
      if (time > currentTime && (nextTime === null || time < nextTime)) {
        nextTime = time;
        highlightItem = prayers[i];
      }
    }

    // If the next time is not found in the current day, search in the next day
    if (nextTime === null && highlightItem === null) {
      const nextDay = new Date(currentTime.getTime() + 24 * 60 * 60 * 1000);
      for (let i = 0; i < prayers.length; i++) {
        const timeParts = prayers[i].timeValues.split(":");
        const time = new Date(nextDay);
        time.setHours(parseInt(timeParts[0]));
        time.setMinutes(parseInt(timeParts[1]));
        if (nextTime === null || time < nextTime) {
          nextTime = time;
          highlightItem = prayers[i];
        }
      }
    }

    // Calculate the distance to the next time
    var distanceMs = nextTime.getTime() - currentTime.getTime();
    var distanceHours = Math.floor(distanceMs / 3600000);
    var distanceMinutes = Math.floor((distanceMs % 3600000) / 60000);

    // prayer item update
    const updatedPrayerItems = prayers.map((pray) =>
      pray.name === highlightItem.name ? { ...pray, highlight: true } : pray
    );

    setTime({
      ...time,
      hours: distanceHours,
      minutes: distanceMinutes,
    });
    setPrayerItems(updatedPrayerItems);
  };

  useEffect(() => {
    let timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  });

  const prayerItem = prayerItems.find((prayer) => prayer.highlight);

  return (
    <div className="px-20 flex flex-col justify-center">
      <div className="bg-white-500">
        <div className="px-5 grid grid-cols-3">
          <div className="col-span-1"></div>
          <div className="col-span-1 text-lg font-medium text-blue-500">
            ATHAN
          </div>
          <div className="col-span-1 text-lg font-medium text-blue-500">
            IQAMAH
          </div>
        </div>
        {prayerItems.map((prayer) => (
          <div
            className={`px-2 grid grid-cols-3 ${
              prayer?.highlight
                ? "bg-blue-500 text-white rounded-md"
                : " text-blue-500"
            }`}
            key={prayer.name}
          >
            <div className="col-span-1 text-lg font-medium ">{prayer.name}</div>
            <div className="col-span-1 text-lg font-medium">
              {prayer.athan.hour}:{prayer.athan.minutes}
            </div>
            <div className="col-span-1 text-lg font-medium">
              {prayer.iqamah.hour}:{prayer.iqamah.minutes}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-10 bg-blue-500 min-h-[20rem] rounded-lg flex justify-center items-center text-white">
        {time !== null && (
          <>
            <CountDown hours={time.hours} minutes={time.minutes} seconds={0} />
          </>
        )}
      </div>
    </div>
  );
};

export default PrayerAdvertise;
